import { Component, EventEmitter, inject } from '@angular/core';
import { Languages } from '@rci/common';
import { CHANGE_PAYMENT_METHOD_URL, OVERVIEW_ROUTE } from '@rci/self-serve-fido/app.constant';
import { ModalInjectableData } from '@rogers/cdk/common/classes';
import { AutopayPromoDetails } from '../autopay-promo.model';
import { ModalComponent, ModalModule } from '@rogers/cdk/modal';
import { AutopayPromoDetailsBodyComponent } from '../autopay-promo-details-body/autopay-promo-details-body.component';
import { ButtonComponent } from '@rogers/cdk/button';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fss-autopay-promo-details',
  templateUrl: './autopay-promo-details.component.html',
  imports: [ModalModule, AutopayPromoDetailsBodyComponent, ButtonComponent, TranslatePipe],
})
export class AutopayPromoDetailsComponent {
  private readonly modalData = inject(ModalInjectableData);

  emitUserAction: EventEmitter<string> = new EventEmitter<string>();
  language: string;
  autopayPromotionDetails: AutopayPromoDetails;

  constructor() {
    this.language = this.modalData.source.language;
    this.autopayPromotionDetails = this.modalData.source.promotionDetails;
  }

  get modalVariant() {
    return this.totalAutopayPromotions === 0 ? ('error' as ModalComponent['variant']) : null;
  }

  get dateFormat() {
    return this.language === Languages.EN ? 'MMMM dd, yyyy' : 'dd MMMM yyyy';
  }

  get totalAutopayPromotions() {
    return this.autopayPromotionDetails.promotions?.length;
  }

  close(action = '') {
    this.emitUserAction.emit(action);
  }

  navigate(page = '') {
    const url = page === 'overview' ? OVERVIEW_ROUTE : CHANGE_PAYMENT_METHOD_URL;
    this.emitUserAction.emit(url);
  }
}
